export interface PaperlessDiscountPayload {
  FormInstanceTypePaperless: PaperlessDiscountModel;
}

export interface PaperlessDiscountModel {
  policies: DiscountPolicyModel[];
  paperlessIndicator: boolean;
  effectiveDate: string;
  customerId: string;
  partnerId: string;
  templateCode: string;
}

export interface DiscountPolicyModel {
  policyNumber: string;
  producerId: string;
}
